// Actions
export const setPages = ({ commit }, payload) => {
  commit('SET_PAGES', payload)
}
export const setPagesLoading = ({ commit }, payload) => {
  commit('SET_PAGES_LOADING', payload)
}

export const setPageContent = ({ commit }, payload) => {
  commit('SET_PAGE_CONTENT', payload)
}
export const setPageContentLoading = ({ commit }, payload) => {
  commit('SET_PAGE_CONTENT_LOADING', payload)
}

export const setFilters = ({ commit }, payload) => {
  commit('SET_FILTERS', payload)
}
export const updateFilter = ({ commit }, payload) => {
  commit('UPDATE_FILTER', payload)
}
export const resetFilters = ({ commit }, payload) => {
  commit('RESET_FILTERS', payload)
}
export const setAnalysisBi = ({ commit }, payload) => {
  commit('SET_ANALYSIS_BI', payload)
}
export const addAnalysisBi = ({ commit }, payload) => {
  commit('ADD_ANALYSIS_BI', payload)
}
export const setAnalysisBiLoading = ({ commit }, payload) => {
  commit('SET_ANALYSIS_BI_LOADING', payload)
}

export const setModeloServirOverview = ({ commit }, payload) => {
  commit('SET_MODELO_SERVIR_OVERVIEW', payload)
}
export const addModeloServirOverview = ({ commit }, payload) => {
  commit('ADD_MODELO_SERVIR_OVERVIEW', payload)
}
export const setModeloServirOverviewLoading = ({ commit }, payload) => {
  commit('SET_MODELO_SERVIR_OVERVIEW_LOADING', payload)
}

export const setModeloServirProductivity = ({ commit }, payload) => {
  commit('SET_MODELO_SERVIR_PRODUCTIVITY', payload)
}
export const addModeloServirProductivity = ({ commit }, payload) => {
  commit('ADD_MODELO_SERVIR_PRODUCTIVITY', payload)
}
export const setModeloServirProductivityLoading = ({ commit }, payload) => {
  commit('SET_MODELO_SERVIR_PRODUCTIVITY_LOADING', payload)
}

export const setModeloServirIndividual = ({ commit }, payload) => {
  commit('SET_MODELO_SERVIR_INDIVIDUAL', payload)
}
export const addModeloServirIndividual = ({ commit }, payload) => {
  commit('ADD_MODELO_SERVIR_INDIVIDUAL', payload)
}
export const setModeloServirIndividualLoading = ({ commit }, payload) => {
  commit('SET_MODELO_SERVIR_INDIVIDUAL_LOADING', payload)
}

export const setFiltroModeloServir = ({ commit }, payload) => {
  commit('SET_FILTRO_MODELO_SERVIR', payload)
}
